import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { SideNav } from '../SideNav';
import { FolderNavContextProvider } from './FolderNavContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const FolderNav = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(FolderNavContextProvider, {
    isFolderNav: true,
    children: /*#__PURE__*/_jsx(SideNav, Object.assign({}, rest, {
      children: children
    }))
  });
};
FolderNav.displayName = 'FolderNav';